module.exports = __webpack_public_path__ + "static/media/smily.e5da36c0.png";